(() => {
  const root = document.querySelector('[data-elite-collection-grid][data-collection-handle="gaming-pcs"]');
  if (!root) return;
  const products = root.querySelector('[data-collection-products]');
  if (!products) return;
  const mobile = matchMedia('(max-width: 749px)');
  const cards = new WeakMap();
  const labels = [['cpu', 'CPU'], ['gpu', 'Graphics Card'], ['ram', 'Memory'], ['storage', 'Storage']];
  const write = (node, value) => { if (node.textContent !== value) node.textContent = value; };

  function shortTitle(value) {
    return value.replace(/Fractal Design/gi, 'Fractal')
      .replace(/\b(?:Midi|Mid|Full)\s*Tower\b|\b(?:TG|ARGB|RGB|PC Case|Case)\b/gi, '')
      .replace(/\bWHITE\b/g, 'White').replace(/\bBLACK\b/g, 'Black')
      .replace(/\s+/g, ' ').trim() + ' Gaming PC';
  }

  function shortValue(key, value) {
    if (key === 'cpu') return value.replace(/^AMD\s+/i, '').replace(/^Intel\s+Core\s+/i, 'Core ');
    if (key === 'gpu') return value.replace(/^(?:NVIDIA\s+)?GeForce\s+/i, '').replace(/^AMD\s+/i, '');
    if (key === 'ram') return value.match(/\b\d+\s*GB\s*DDR\d\b/i)?.[0] || value;
    return value;
  }

  function storageValue(values) {
    const drives = ['nvme_ssd', 'sata_ssd', 'sata_hdd'].map(key => ({ key, value: values[key] || '' }))
      .filter(drive => drive.value && !/^(?:no |none|not selected)/i.test(drive.value));
    if (!drives.length) return 'Choose storage';
    let ssd = 0, hdd = 0;
    for (const drive of drives) {
      const capacity = drive.value.match(/\b(\d+(?:\.\d+)?)\s*(TB|GB)\b/i);
      if (!capacity) return drives.map(drive => drive.value).join(' + ');
      const amount = Number(capacity[1]) * (/TB/i.test(capacity[2]) ? 1000 : 1);
      if (drive.key === 'sata_hdd') hdd += amount; else ssd += amount;
    }
    const capacity = value => value >= 1000 ? `${Number((value / 1000).toFixed(2))}TB` : `${value}GB`;
    return [ssd ? `${capacity(ssd)} SSD` : '', hdd ? `${capacity(hdd)} HDD` : ''].filter(Boolean).join(' + ');
  }

  function prepare(card) {
    const titleLink = card.querySelector('.epc-spotlight__title a');
    const details = card.querySelector('.epc-spotlight__details');
    const gallery = card.querySelector('[data-spotlight-gallery]');
    const stage = card.querySelector('.epc-spotlight__stage');
    const source = card.querySelector('[data-elite-pc-list-specs]');
    if (!titleLink || !details || !gallery || !stage || !source) return null;
    if (!titleLink.querySelector('.epc-mobile-card__title')) {
      const desktopTitle = document.createElement('span');
      desktopTitle.className = 'epc-mobile-card__desktop-title';
      desktopTitle.textContent = titleLink.textContent;
      const title = document.createElement('span');
      title.className = 'epc-mobile-card__title';
      title.textContent = shortTitle(titleLink.textContent);
      titleLink.replaceChildren(desktopTitle, title);
    }
    let grid = details.querySelector('.epc-mobile-card__specs');
    const cells = {};
    if (grid) {
      for (const [key] of labels) cells[key] = grid.querySelector(`[data-elite-mobile-spec-value="${key}"]`);
      if (Object.values(cells).some(cell => !cell)) return null;
    } else {
      // Keep support for cards inserted by older section responses.
      grid = document.createElement('dl');
      grid.className = 'epc-mobile-card__specs';
      grid.setAttribute('aria-label', 'PC configuration');
      grid.hidden = true;
      for (const [key, label] of labels) {
        const cell = document.createElement('div');
        cell.className = 'epc-mobile-card__spec';
        const icon = source.querySelector(`[data-elite-pc-list-spec="${key === 'storage' ? 'nvme_ssd' : key}"] svg`);
        if (icon) cell.append(icon.cloneNode(true));
        const dt = document.createElement('dt');
        dt.textContent = label;
        const dd = document.createElement('dd');
        dd.dataset.eliteMobileSpecValue = key;
        cell.append(dt, dd);
        grid.append(cell);
        cells[key] = dd;
      }
      card.querySelector('.epc-spotlight__title').after(grid);
    }
    const counter = document.createElement('button');
    counter.className = 'epc-mobile-card__counter';
    counter.type = 'button';
    counter.setAttribute('aria-label', 'Next product image');
    counter.addEventListener('click', () => card.showSlide?.((card.index || 0) + 1));
    gallery.append(counter);
    if (!card.querySelector('.epc-mobile-card__price-label')) {
      const priceLabel = document.createElement('span');
      priceLabel.className = 'epc-mobile-card__price-label';
      priceLabel.textContent = 'Full PC configuration';
      card.querySelector('.epc-spotlight__pricing')?.prepend(priceLabel);
    }

    let start, suppressClickUntil = 0;
    stage.addEventListener('pointerdown', event => {
      start = mobile.matches && event.pointerType !== 'mouse'
        ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
    }, { passive: true });
    stage.addEventListener('pointerup', event => {
      if (!start || start.id !== event.pointerId) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) < 35 || Math.abs(dy) > Math.abs(dx) * .7 || typeof card.showSlide !== 'function') return;
      suppressClickUntil = Date.now() + 500;
      card.showSlide(card.index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    stage.addEventListener('pointercancel', () => { start = null; }, { passive: true });
    stage.addEventListener('click', event => {
      if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    const state = { source, grid, cells, counter };
    cards.set(card, state);
    return state;
  }

  function render() {
    if (!mobile.matches) return;
    for (const card of products.querySelectorAll('epc-featured-spotlight')) {
      if (card.hidden || card.closest('[hidden]')) continue;
      const state = cards.get(card) || prepare(card);
      if (!state) continue;
      // The server may already describe this card's exact published build.
      // Do not overwrite it with the legacy generic defaults while the
      // collection's checked selection is still hydrating.
      const waitingForSelection = state.grid.querySelector('[data-elite-initial-spec-sku]')
        && !state.source.querySelector('[data-elite-pc-list-spec-image][data-component-sku]');
      if (waitingForSelection) continue;
      const values = {};
      for (const row of state.source.querySelectorAll('[data-elite-pc-list-spec]')) {
        if (!row.hidden) values[row.dataset.elitePcListSpec] = row.querySelector('[data-elite-pc-list-spec-value]')?.textContent.trim() || '';
      }
      for (const key of ['cpu', 'gpu', 'ram']) {
        write(state.cells[key], shortValue(key, values[key] || `Choose ${key === 'cpu' ? 'processor' : key === 'gpu' ? 'graphics' : 'memory'}`));
        state.cells[key].title = values[key] || '';
      }
      write(state.cells.storage, storageValue(values));
      const hidden = !values.cpu && !values.gpu && !values.ram;
      if (state.grid.hidden !== hidden) state.grid.hidden = hidden;
      const slides = [...card.querySelectorAll('[data-spotlight-slide]')];
      write(state.counter, `${Math.max(0, slides.findIndex(slide => !slide.hidden)) + 1} / ${slides.length || 1}`);
      state.counter.disabled = slides.length < 2;
    }
  }
  let scheduled = false;
  const schedule = () => {
    if (scheduled || !mobile.matches) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; render(); });
  };
  new MutationObserver(schedule).observe(products, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
  mobile.addEventListener('change', schedule);
  render();
})();
